<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          :loading="loadingCompanies"
          class="v-card-profile"
          color="primary"
        >
          <template v-slot:header>
            <div
              class="pa-3"
            >
              <h4
                class="title font-weight-light"
              >
                Companies
              </h4>
            </div>

            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-3"
              @click="onCompanySelect"
            >
              <v-icon class="pr-3">
                mdi-plus
              </v-icon>Add Company
            </v-btn>
          </template>
          <v-progress-circular
            v-if="loadingCompanies"
            :size="50"
            color="primary"
            indeterminate
          />
          <profile-list
            v-else
            :items="companies"
            @select="selectCompany"
          />
        </material-card>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <material-card
          v-if="selectedCompany"
          class="v-card-profile"
          color="primary"
        >
          <template v-slot:header>
            <div
              class="pa-3"
            >
              <h4
                class="title font-weight-light"
              >
                {{ selectedCompany.name }}
              </h4>
            </div>

            <v-spacer />
            <v-menu
              bottom
              left
              offset-y
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  class="toolbar-items"
                  icon
                  :to="user ? null : '/login?redirect=' + $route.path"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="secondary">
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list
                  dense
                >
                  <v-list-item
                    @click="() => onCompanySelect(selectedCompany)"
                  >
                    <v-list-item-title>
                      Edit Company
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="() => onMollieSelect(selectedCompany)"
                  >
                    <v-list-item-title>
                      Edit Mollie
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onUserSelect"
                  >
                    <v-list-item-title>
                      Add User
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onSiteSelect"
                  >
                    <v-list-item-title>
                      Add Site
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </template>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <h6 class="overline">
                Users
              </h6>
              <v-progress-circular
                v-if="loadingUsers"
                :size="50"
                color="primary"
                indeterminate
              />
              <profile-list
                v-else
                :items="users"
                @edit="onUserSelect"
                @delete="onUserDelete"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <h6 class="overline">
                Sites
              </h6>
              <profile-list
                :items="getSites()"
                @edit="onSiteSelect"
                @delete="onSiteDelete"
              />
            </v-col>
          </v-row>
        </material-card>
      </v-col>
    </v-row>
    <form-dialog
      ref="dialog"
      :title="currentTitle"
      :schema="currentSchema"
      :item="currentItem"
      @submit="currentSubmit"
    />
    <yes-no-dialog
      ref="yesno"
      @yes="currentDelete"
    />
  </v-container>
</template>

<script>
  import FormDialog from '../components/core/FormDialog.vue'
  import YesNoDialog from '../components/core/YesNoDialog.vue'
  import ProfileList from '../components/core/ProfileList.vue'
  import moment from 'moment'
  export default {
    components: {
      FormDialog,
      YesNoDialog,
      ProfileList
    },
    data () {
      return {
        loadingCompanies: false,
        loadingUsers: false,
        currentTitle: '',
        currentSchema: {},
        currentSubmit: () => {},
        currentDelete: () => {},
        currentItem: {},
        companySchema: {
          name: {
            type: 'text',
            label: 'Name'
          }
        },
        userSchema: {
          name: {
            type: 'text',
            label: 'Name'
          },
          email: {
            type: 'email',
            label: 'Email'
          },
          password: {
            type: 'password',
            appendIcon: 'mdi-eye',
            label: 'Password'
          },
          role: {
            type: 'select',
            label: 'Role',
            items: ['Customer', 'Editor', 'Admin']
          }
        },
        siteSchema: {
          name: {
            type: 'text',
            label: 'Name'
          },
          domain: {
            type: 'text',
            label: 'Domain'
          },
          repoName: {
            type: 'text',
            label: 'Repository Name'
          }
        },
        mollieSchema: {
          liveKey: {
            type: 'text',
            label: 'Live Key'
          },
          testKey: {
            type: 'text',
            label: 'Test Key'
          },
          partnerId: {
            type: 'text',
            label: 'Partner Id'
          },
          profileId: {
            type: 'text',
            label: 'Profile Id'
          },
          shippingCost: {
            type: 'text',
            label: 'Shipping Cost'
          },
          shippingCostFree: {
            type: 'text',
            label: 'Shipping Cost Free'
          },
          notification: {
            type: 'text',
            label: 'Notification'
          }
        },
        companies: [],
        users: [],
        selectedCompany: null,
        user: {
          ...this.$store.state.user
        },
      }
    },
    computed: {
      company: function () {
        return this.$store.state.company
      },
      sites: function () {
        return this.$store.state.sites
      }
    },
    created () {
      this.selectedCompany = this.company
      this.getCompanies()
      this.getUsers()
    },
    methods: {
      moment,
      selectCompany (company) {
        this.selectedCompany = company
        this.getUsers()
      },
      onCompanySelect (company) {
        this.currentSchema = this.companySchema
        this.currentSubmit = this.updateCompany
        if (company && company.companyId) {
          this.currentItem = company
          this.currentTitle = 'Update Company'
          this.currentMethod = 'put'
        } else {
          this.currentItem = {}
          this.currentTitle = 'Add Company'
          this.currentMethod = 'post'
        }
        this.$refs.dialog.open()
      },
      onMollieSelect (company) {
        this.currentSchema = this.mollieSchema
        this.currentSubmit = this.updateMollie
        this.currentMethod = 'put'
        this.currentItem = {
          companyId: company.companyId
        }
        this.currentTitle = 'Update MollieSettings'

        this.$refs.dialog.open()

        this.api.get('company/mollie/' + company.companyId)
          .then(result => {
            if (result.data) {
              this.currentItem = result.data
            }
          }, error => {
            this.error = error
          })
      },
      onSiteDelete (site) {
        this.currentDelete = (done) => this.deleteSite(site, done)
        this.$refs.yesno.open(`Delete ${site.name}`, `Are you sure you want to delete ${site.name} from ${this.selectedCompany.name}?`)
      },
      onSiteSelect (site) {
        this.currentSchema = this.siteSchema
        this.currentSubmit = this.updateSite
        if (site && site.siteId) {
          this.currentItem = site
          this.currentTitle = 'Update Site'
          this.currentMethod = 'put'
        } else {
          this.currentItem = {}
          this.currentTitle = 'Add Site'
          this.currentMethod = 'post'
        }
        this.$refs.dialog.open()
      },
      onUserDelete (user) {
        this.currentDelete = (done) => this.deleteUser(user, done)
        this.$refs.yesno.open(`Remove ${user.name}`, `Are you sure you want to remove ${user.name} from ${this.selectedCompany.name}?`)
      },
      onUserSelect (user) {
        this.currentSchema = this.userSchema
        this.currentSubmit = this.updateUser
        if (user && user.userId) {
          this.currentItem = user
          this.currentTitle = 'Update User'
          this.currentMethod = 'put'
        } else {
          this.currentItem = {
            password: this.randPassword(5, 3, 2, 1)
          }
          this.currentTitle = 'Add User'
          this.currentMethod = 'post'
        }
        this.$refs.dialog.open()
      },
      updateUser (submit) {
        var user = submit.item
        if (!user.companyId) {
          user.companyId = this.selectedCompany.companyId
        }
        this.api[this.currentMethod]('user', user)
          .then(result => {
            this.getUsers()
            if (this.user.userId === result.data.userId) {
              this.$store.commit('setUser', result.data)
              localStorage.setItem('claim', JSON.stringify(result.data))
            }
            submit.done()
          }, error => {
            this.error = error
            submit.done()
          })
      },
      updateCompany (submit) {
        var company = submit.item
        this.api[this.currentMethod]('company', company)
          .then(result => {
            this.getCompanies()
            if (this.company.companyId === result.data.companyId) {
              this.$store.commit('setCompany', result.data)
            }
            submit.done()
          }, error => {
            this.error = error
            submit.done()
          })
      },
      updateMollie (submit) {
        var mollie = submit.item
        this.api[this.currentMethod]('company/mollie', mollie)
          .then(result => {
            submit.done()
          }, error => {
            this.error = error
            submit.done()
          })
      },
      updateSite (submit) {
        var site = submit.item
        if (!site.companyId) {
          site.companyId = this.selectedCompany.companyId
        }
        this.api[this.currentMethod]('sites', site)
          .then(result => {
            var newSites = []
            if (this.currentMethod === 'put') {
              newSites = this.sites.map(existingSite => {
                if (existingSite.siteId === result.data.siteId) {
                  return result.data
                }
                return existingSite
              })
            } else if (this.currentMethod === 'post') {
              newSites = [result.data, ...this.sites]
            }
            this.$store.commit('setSites', newSites)
            submit.done()
          }, error => {
            this.error = error
            submit.done()
          })
      },
      getSites () {
        var sites = this.sites.filter(site => site.companyId === this.selectedCompany.companyId)
        sites.forEach(site => {
          site.sub1 = site.domain
          site.sub2 = this.moment(site.created).format('DD-MM-YY')
        })
        return sites
      },
      getUsers () {
        if (this.selectedCompany && !this.loadingUsers) {
          this.loadingUsers = true
          this.api.get('user/list/' + this.selectedCompany.companyId)
            .then(result => {
              var users = result.data
              users.forEach(user => {
                user.sub1 = user.email
                user.sub2 = this.moment(user.created).format('DD-MM-YY')
              })
              this.users = users
              this.loadingUsers = false
            }, error => {
              this.loadingUsers = false
              this.error = error
            })
        }
      },
      getCompanies () {
        if (!this.loadingCompanies) {
          this.loadingCompanies = true
          this.api.get('company/list')
            .then(result => {
              var companies = result.data
              companies.forEach(company => {
                company.sub1 = this.moment(company.created).format('DD-MM-YY')
              })
              this.companies = companies
              this.loadingCompanies = false
            }, error => {
              this.loadingCompanies = false
              this.error = error
            })
        }
      },
      deleteUser (user, done) {
        this.api.delete('user/' + user.userId)
          .then(result => {
            this.getUsers()
            done()
          }, error => {
            done()
            this.error = error
          })
      },
      deleteSite (site, done) {
        this.api.delete('sites/' + site.siteId)
          .then(result => {
            var newSites = this.sites.filter(existingSite => existingSite.siteId !== site.siteId)
            this.$store.commit('setSites', newSites)
            done()
          }, error => {
            done()
            this.error = error
          })
      },
      randPassword (letters, numbers, upper, special) {
        var chars = [
          'abcdefghijklmnopqrstuvwxyz', // letters
          '0123456789', // numbers
          'ABCDEFGHIJKLMNOPQRSTUVWXYZ', // either
          '@#!?' // special
        ]

        return [letters, numbers, upper, special].map(function (len, i) {
          return Array(len).fill(chars[i]).map(function (x) {
            return x[Math.floor(Math.random() * x.length)]
          }).join('')
        }).concat().join('').split('').sort(function () {
          return 0.5 - Math.random()
        }).join('')
      }
      // invoke like so: randPassword(5,3,2);
    }
  }
</script>
